import React from 'react';

import ReservationForm from 'features/reservation/components/ReservationForm';
import { useReservationData } from '../hooks/useReservationData';
import { type ReservationInfoType } from 'types/Reservation';
import { type ReservationProps } from 'types/ScreenTypes';

const ReservationScreen: React.FC<ReservationProps> = ({ navigation }) => {
  const { schedule, reservationSetting } = useReservationData();

  const handleSubmit = (values: ReservationInfoType, actions: any): void => {
    const submitValues = {
      ...values,
      actions,
    };
    navigation.navigate('ReservationConfirm', submitValues);
  };

  return (
    <ReservationForm
      schedule={schedule}
      reservationSetting={reservationSetting}
      onSubmit={handleSubmit}
    />
  );
};

export default ReservationScreen;
